export const API_URL = "https://cms-api.jupi.vn";
export const WEB_URL = "https://jupi.vn";
export const CDN_URL = "https://cdn.jupi.vn";
export const VERSION_API = "v1";
export const copyright = "ThanhPhat © 2026. All rights reserved.";
export const logoMiniPath = "/logo/ts247logosmall.webp";
export const logoPath = "/logo/jupi-big-logo.png";

